import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "../ErrorMessage/errorMessage";
import * as S from "../../cmsForm.style";
export var CustomCheckbox = function(_param) {
    var name = _param.name, label = _param.label, isColMiddle = _param.isColMiddle, isHidden = _param.isHidden, isDisabled = _param.isDisabled, isPendingRequest = _param.isPendingRequest, props = _object_without_properties(_param, [
        "name",
        "label",
        "isColMiddle",
        "isHidden",
        "isDisabled",
        "isPendingRequest"
    ]);
    var ref;
    var ref1 = useFormContext(), register = ref1.register, errors = ref1.formState.errors;
    var error = (ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message;
    return /*#__PURE__*/ _jsxs(S.StyledCheckboxContainer, {
        isColMiddle: isColMiddle,
        isHidden: isHidden,
        children: [
            /*#__PURE__*/ _jsxs(S.StyledCheckboxLabel, {
                children: [
                    /*#__PURE__*/ _jsx(S.StyledCheckbox, _object_spread_props(_object_spread({}, props, register(name)), {
                        disabled: isDisabled || isPendingRequest
                    })),
                    label
                ]
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                error: error
            })
        ]
    });
};
